import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectReportService {

  constructor(private http: HttpClient) { }

  //Upload Project Report File
  UploadProjectReportDocument(model: any): Observable<any> {
    const url = `${environment.gateway_url}/uploadprojectreportdocument`
    return this.http.post<Observable<any>>(url, model, { withCredentials: false });
  }

  //Download Project Report File
  DownloadProjectReportDocument(projectId: any, projectFileId: any, fileName: any): Observable<any> {
    const url = `${environment.gateway_url}/downloadprojectreportdocument/${projectId}/${projectFileId}/${fileName}`
    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  //Delete Project Report File/Image/Questions & Responses
  DeleteProjectReportData(projectId: any, model: any): Observable<any> {
    const url = `${environment.gateway_url}/deleteprojectreportdata/${projectId}`
    return this.http.post<Observable<any>>(url, model, { withCredentials: false });
  }
}
 